/* eslint-disable @typescript-eslint/no-explicit-any */
import { AnalyticsEvent, AnalyticsEventMap } from './type';

export function makeEvent<E extends keyof AnalyticsEventMap>(
  event: E,
  params: AnalyticsEventMap[E],
): Extract<AnalyticsEvent, { event: E }> {
  return {
    event,
    timestamp: Date.now(),
    ...(params as any),
  } as Extract<AnalyticsEvent, { event: E }>;
}
